// extracted by mini-css-extract-plugin
export default {"mainContainer":"FireboardLayout_mainContainer__vIZCO","mainPopUpConatiner":"FireboardLayout_mainPopUpConatiner__vK9Lk","menuContainer":"FireboardLayout_menuContainer__asR8R"};